
import PropTypes from 'prop-types'
import React from 'react'
import { FlexItem } from '../flexgrid'
import './sidebar.css'

const Sidebar = props => (
  <FlexItem width={180 + 30}>
    <div className='InfoSheetSidebar'>
      {props.children}
    </div>
  </FlexItem>
)

Sidebar.propTypes = {
  children: PropTypes.array.isRequired
}

Sidebar.displayName = 'InfoSheet Sidebar'

export default Sidebar



// WEBPACK FOOTER //
// ./ui/InfoSheet/sidebar.js